import {
  MdCancel,
  MdCheckCircle,
  MdOutlineReplayCircleFilled,
  MdOutlineError,
} from "react-icons/md";
import { GrTransaction } from "react-icons/gr";
import TotalSpent from "views/admin/default/components/TotalSpent";
import TransactionPieChartCard from "./components/TransactionPieChartCard";
import TransactionAnalysisPieChartCard from "./components/TransactionAnalysisPieChartCard";
import ADPaymentsList from "./components/ADPaymentsList";
import Treasury from "./components/Treasury";
import Settlements from "./components/Settlements";
import PaymentsListDashboard from "../payments/components/PaymentsListDashboard";
import { getAllTabs, getClientDetails, getOrganizationDetails, getTransactionByCurrency } from "api/graphQL_dashboard";
import { getRecentPayments } from "api/payments";
import { getAllsettlementDashboard } from "api/settlement";
import { getCardType } from "api/graphQL_payments";
import { getAllGatewaysSecond } from "api/graphQL_gateways";
import { getSingleRole } from "api/graphQL_role";
import { ClientContext } from "ClientProvider";
import DivLoader from "components/divloader/DivLoader";
import DateRange from "components/fields/DateRange";
import { MultiSelect } from "react-multi-select-component";
import { PaymentRowObj } from "../payments";
import { useEffect, useState, useContext } from "react";
import { getId } from "utils/auth";
import moment from "moment";
import { getClientTreasuryDashboard } from "api/graphQL_clients";

/* ─── design tokens (shared across this file) ─── */
const T = {
  blue:   { bg: "#eff6ff", border: "#bfdbfe", icon: "#2563eb", text: "#1e40af" },
  green:  { bg: "#f0fdf4", border: "#bbf7d0", icon: "#16a34a", text: "#15803d" },
  red:    { bg: "#fff7f7", border: "#fecaca", icon: "#dc2626", text: "#b91c1c" },
  amber:  { bg: "#fffbeb", border: "#fde68a", icon: "#d97706", text: "#b45309" },
  orange: { bg: "#fff7ed", border: "#fed7aa", icon: "#ea580c", text: "#c2410c" },
};

const TIME_FRAMES = ["today", "yesterday", "weekly", "monthly", "yearly", "all"];

/* ══════════════════════════════════════════════════════════
   DASHBOARD
══════════════════════════════════════════════════════════ */
const Dashboard = () => {
  const { singleRoleData, setSingleRoleData, dashboardData, setDashboardData } = useContext(ClientContext);
  const [timeFrameTop, setTimeFrameTop] = useState<any>("today");
  const [orgDetails, setOrgDetails] = useState<any>([]);
  const [selectOrg, setSelectOrg] = useState<any>([]);
  const [clientDetails, setClientDetails] = useState<any>([]);
  const [selectClient, setSelectClientDetails] = useState<any>([]);
  const [cardDetails, setCardDetails] = useState<any>([]);
  const [selectCard, setSelectCard] = useState<any>([]);
  const [datesTop, setDatesTop] = useState<[Date | null, Date | null]>();

  const [isTreasuryLoading, setIsTreasuryLoading] = useState<boolean>(false);
  const [allTreasury, setAllTreasury] = useState([]);
  const [totalTreasury, setTotalTreasury] = useState<any>([]);

  const [isSettlementsLoading, setIsSettlementsLoading] = useState<boolean>(false);
  const [allSettlements, setAllSettlements] = useState([]);
  const [totalSettlements, setTotalSettlements] = useState<any>([]);

  const fetchSingleRole = () => {
    getSingleRole(getId()).then((d) => setSingleRoleData(d ?? [])).catch(() => {});
  };
  const fetchOrgDetails = () => {
    getOrganizationDetails().then((d) => {
      const m = d?.map((x: any) => ({ ...x?.organization, label: x?.organization?.name, value: x?.organization?.id }));
      setOrgDetails(m); setSelectOrg(m);
    }).catch(() => {});
  };
  const fetchClientDetails = () => {
    getClientDetails({ org_ids: selectOrg?.length > 0 ? selectOrg?.map((m: any) => m?.id)?.toString() : "all" })
      .then((d) => { const m = d?.map((x: any) => ({ ...x, label: x?.name, value: x?.id })); setClientDetails(m); setSelectClientDetails(m); })
      .catch(() => {});
  };
  const fetchCardTypeDetails = () => {
    getCardType().then((d) => { const m = d?.map((c: any) => ({ label: c, value: c })); setCardDetails(m); setSelectCard(m); }).catch(() => {});
  };
  const fetchClientTreasury = () => {
    setIsTreasuryLoading(true);
    const ids = selectClient?.length > 0 ? selectClient.map((m: any) => m?.id) : [];
    getClientTreasuryDashboard(ids,timeFrameTop,datesTop)
      .then((d) => {
        setAllTreasury(d[0].treasury);
        const treasuryObj = JSON.parse(d[0].total_treasury || "{}");

        const formattedTreasury = Object.keys(treasuryObj).reduce(
          (acc: any, currency: any) => {
            acc[currency] = {
              credit: Number(
                treasuryObj[currency]?.credit || 0
              ).toFixed(4),
              debit: Number(
                treasuryObj[currency]?.debit || 0
              ).toFixed(4),
              remaining: Number(
                treasuryObj[currency]?.remaining || 0
              ).toFixed(4),
            };
            return acc;
          },
          {}
        );
        
        setTotalTreasury(formattedTreasury);
        setIsTreasuryLoading(false);
      })
      .catch((err) =>
       setIsTreasuryLoading(false)
      );
  };
  const fetchClientSettlements = () => {
    setIsSettlementsLoading(true);
    const ids = selectClient?.length > 0 ? selectClient.map((m: any) => m?.id) : [];
    getAllsettlementDashboard(ids,timeFrameTop,datesTop)
      .then((d) => {
        setAllSettlements(d.settlements);        
        setTotalSettlements(d.totals || "{}");
        setIsSettlementsLoading(false);
      })
      .catch((err) =>
       setIsSettlementsLoading(false)
      );
  };

  useEffect(() => {
    if (selectOrg.length > 0 && selectClient.length > 0) {
      fetchClientTreasury();
      fetchClientSettlements();
    }
  }, [selectOrg, selectClient,timeFrameTop,datesTop]);

  useEffect(() => { fetchClientDetails(); }, [selectOrg]);
  useEffect(() => { fetchSingleRole(); fetchOrgDetails(); fetchClientDetails(); fetchCardTypeDetails(); }, []);

  const handleDateRangeChange = (r: [Date | null, Date | null]) => {
    if (r[0] && r[1]) { setDatesTop([new Date(moment(r[0]).format("YYYY-MM-DD")), new Date(moment(r[1]).format("YYYY-MM-DD"))]); setTimeFrameTop("custom"); }
    else { setTimeFrameTop("today"); setDatesTop(null); }
  };

  const perm = singleRoleData[0]?.dashboard?.value;
  const dashboardHeader      = perm?.view_dashboard_header;
  const recentTtransactions  = perm?.view_dashboard_recent_transactions;
  const clientTreasury  = perm?.view_dashboard_client_treasury;
  const clientSettlement  = perm?.view_dashboard_client_settlement;
  const approvedTransPiechart = perm?.view_dashboard_approved_transactions_piechart;
  const declinedTransPiechart = perm?.view_dashboard_declined_transactions_piechart;
  const approvedTransList    = perm?.view_dashboard_approved_transactions_list;
  const declinedTransList    = perm?.view_dashboard_declined_transactions_list;
  const transactionAnaylsis  = perm?.view_dashboard_transaction_anaylsis;
  const wavechart            = perm?.view_dashboard_wavechart;
  const show_paymentName     = perm?.show_dashboard_method_name;

  const sharedProps = { selectOrg, selectClient, selectCard, datesTop, timeFrameTop };

  return (
    <div className="db-root">
      <div className="db-filter-card">
        <div className="db-toprow">
          <div className="db-page-title">
            <div className="db-page-icon">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/>
                <rect x="3" y="14" width="7" height="7" rx="1"/><rect x="14" y="14" width="7" height="7" rx="1"/>
              </svg>
            </div>
            <div>
              <h1 className="db-heading">Dashboard</h1>
              <p className="db-subheading">Payment analytics & insights</p>
            </div>
          </div>
          <label className="db-mode-toggle">
            <input type="checkbox" className="db-toggle-inp" checked={!!dashboardData} onChange={() => setDashboardData(!dashboardData)} />
            <div className="db-toggle-track">
              <div className="db-toggle-thumb" />
            </div>
            <div className="db-mode-labels">
              <span className={`db-mode-lbl${!dashboardData ? " db-mode-lbl--active-test" : ""}`}>Test</span>
              <span className="db-mode-sep">/</span>
              <span className={`db-mode-lbl${dashboardData ? " db-mode-lbl--active-live" : ""}`}>Live</span>
            </div>
          </label>
        </div>

        <div className="db-divider" />

        <div className="db-filter-grid">
          {/* Org */}
          <div className="db-filter-group">
            <label className="db-filter-label">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>
              Organization
            </label>
            <MultiSelect options={orgDetails} value={selectOrg} onChange={setSelectOrg} labelledBy="Organization(s)" isCreatable={false}
              className="db-ms"
              overrideStrings={{ noOptions: "No organizations found" }}
              valueRenderer={(s, o) => s.length === 0 ? "All organizations" : s.length === o.length ? "All organizations" : s.map(x => x.label).join(", ")}
            />
          </div>

          {/* Client */}
          <div className="db-filter-group">
            <label className="db-filter-label">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
              Client
            </label>
            <MultiSelect options={clientDetails} value={selectClient} onChange={setSelectClientDetails} labelledBy="Client(s)" isCreatable={false}
              className="db-ms"
              overrideStrings={{ noOptions: "No clients found" }}
              valueRenderer={(s, o) => s.length === 0 ? "All clients" : s.length === o.length ? "All clients" : s.map(x => x.label).join(", ")}
            />
          </div>

          {/* Card type */}
          <div className="db-filter-group">
            <label className="db-filter-label">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><rect x="1" y="4" width="22" height="16" rx="2"/><line x1="1" y1="10" x2="23" y2="10"/></svg>
              Card Type
            </label>
            <MultiSelect options={cardDetails} value={selectCard} onChange={setSelectCard} labelledBy="Card Type(s)" isCreatable={false}
              className="db-ms"
              overrideStrings={{ noOptions: "No card types found" }}
              valueRenderer={(s, o) => s.length === 0 ? "All card types" : s.length === o.length ? "All card types" : s.map(x => x.label).join(", ")}
            />
          </div>

          {/* Date range */}
          <div className="db-filter-group">
            <label className="db-filter-label">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
              Custom Date Range
            </label>
            <div className="db-daterange">
              <DateRange onDateChange={handleDateRangeChange} />
            </div>
          </div>
        </div>

        <div className="db-divider" />

        <div className="db-tf-row">
          <span className="db-filter-label" style={{ marginBottom: 0, flexShrink: 0 }}>
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
            Time Frame
          </span>
          <div className="db-tf-pills">
            {TIME_FRAMES.map((t) => (
              <button key={t} className={`db-pill${timeFrameTop === t ? " db-pill--active" : ""}`} onClick={() => setTimeFrameTop(t)}>
                {t.charAt(0).toUpperCase() + t.slice(1)}
              </button>
            ))}
          </div>
        </div>
      </div>

      {dashboardHeader && <InfoTabs {...sharedProps} />}

      <div className="db-content-grid">
        {recentTtransactions && (
          <div className="db-span-full">
            <LatestPayments {...sharedProps} paymentName={show_paymentName} />
          </div>
        )}
        {clientTreasury && (
        <div className="db-span-full">
          <Treasury  isLoading={isTreasuryLoading} allTreasury={allTreasury} totalTreasury={totalTreasury}/>
        </div>
        )}
        {clientSettlement && (
        <div className="db-span-full">
          <Settlements  isLoading={isSettlementsLoading} allSettlements={allSettlements} totalSettlements={totalSettlements}/>
        </div>
        )}
        {(approvedTransPiechart || declinedTransPiechart) && (
          <div className="db-pie-pair">
            {approvedTransPiechart && <TransactionPieChartCard type="approved" {...sharedProps} />}
            {declinedTransPiechart && <TransactionPieChartCard type="decline" {...sharedProps} />}
          </div>
        )}

        {approvedTransList && timeFrameTop && <AllADPayments type="approved" {...sharedProps} />}
        {declinedTransList && timeFrameTop && <AllADPayments type="decline" {...sharedProps} />}
        {wavechart && <TotalSpent {...sharedProps} />}
        {transactionAnaylsis && <TransactionAnalysisPieChartCard type="approved" {...sharedProps} />}
      </div>

      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');

        .db-root {
          font-family: 'Plus Jakarta Sans', sans-serif;
          min-height: 100vh;
          display: flex; flex-direction: column; gap: 20px;
        }

        /* ── Filter card ── */
        .db-filter-card {
          background: #ffffff;
          border-radius: 18px;
          padding: 22px 28px;
          border: 1px solid #e2e8f0;
          box-shadow: 0 2px 8px rgba(15,23,42,0.06), 0 1px 2px rgba(15,23,42,0.04);
        }

        /* Top row: title + toggle */
        .db-toprow {
          display: flex; align-items: center; justify-content: space-between;
          gap: 16px; margin-bottom: 18px; flex-wrap: wrap;
        }
        .db-page-title { display: flex; align-items: center; gap: 12px; }
        .db-page-icon {
          width: 40px; height: 40px; border-radius: 11px;
          background: linear-gradient(135deg, #eff6ff, #dbeafe);
          border: 1.5px solid #bfdbfe;
          display: flex; align-items: center; justify-content: center;
          color: #2563eb; flex-shrink: 0;
        }
        .db-heading { font-size: 18px; font-weight: 800; color: #0f172a; letter-spacing: -0.4px; margin-bottom: 1px; line-height:22px}
        .db-subheading { font-size: 12px; color: #94a3b8; font-weight: 500; }

        /* Toggle */
        .db-mode-toggle { display: flex; align-items: center; gap: 10px; cursor: pointer; }
        .db-toggle-inp { display: none; }
        .db-toggle-track {
          width: 46px; height: 26px; border-radius: 100px;
          background: #e2e8f0; position: relative; transition: background 0.22s;
          flex-shrink: 0;
        }
        .db-toggle-inp:checked ~ .db-toggle-track { background: #2563eb; }
        .db-toggle-thumb {
          position: absolute; top: 3px; left: 3px;
          width: 20px; height: 20px; border-radius: 50%;
          background: #fff; transition: transform 0.22s;
          box-shadow: 0 1px 4px rgba(0,0,0,0.18);
        }
        .db-toggle-inp:checked ~ .db-toggle-track .db-toggle-thumb { transform: translateX(20px); }
        .db-mode-labels { display: flex; align-items: center; gap: 4px; }
        .db-mode-sep { font-size: 13px; color: #cbd5e1; }
        .db-mode-lbl { font-size: 13px; font-weight: 600; color: #94a3b8; transition: color 0.18s; }
        .db-mode-lbl--active-test { color: #ea580c; }
        .db-mode-lbl--active-live { color: #16a34a; }

        .db-divider { height: 1px; background: #f1f5f9; margin: 4px 0 18px; }

        /* Filter grid */
        .db-filter-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
          gap: 16px;
          margin-bottom: 4px;
        }
        .db-filter-group { display: flex; flex-direction: column; gap: 7px; }
        .db-filter-label {
          display: flex; align-items: center; gap: 5px;
          font-size: 11.5px; font-weight: 700; color: #374151;
          letter-spacing: 0.4px; text-transform: uppercase;
        }
        .db-ms { font-family: 'Plus Jakarta Sans', sans-serif !important; }
        .db-daterange { }

        /* Time frame row */
        .db-tf-row { display: flex; align-items: center; gap: 12px; flex-wrap: wrap; }
        .db-tf-pills { display: flex; flex-wrap: wrap; gap: 6px; }
        .db-pill {
          padding: 6px 14px;
          border-radius: 8px;
          border: 1.5px solid #e2e8f0;
          background: #f8fafc;
          font-family: 'Plus Jakarta Sans', sans-serif;
          font-size: 12.5px; font-weight: 600;
          color: #64748b; cursor: pointer;
          transition: all 0.15s;
        }
        .db-pill:hover { border-color: #93c5fd; color: #2563eb; background: #eff6ff; }
        .db-pill--active { border-color: #2563eb !important; background: #eff6ff !important; color: #1d4ed8 !important; }

        /* Content grid */
        .db-content-grid {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 20px;
        }
        .db-span-full { grid-column: 1 / -1; }
        .db-pie-pair { display: grid; grid-template-columns: 1fr 1fr; gap: 20px; grid-column: 1 / -1;align-items: stretch; }

        @media (max-width: 1024px) {
          .db-content-grid { grid-template-columns: 1fr; }
          .db-pie-pair { grid-template-columns: 1fr; }
        }
        @media (max-width: 768px) {
          .db-root { padding: 14px; gap: 14px; }
          .db-filter-card { padding: 18px 16px; }
          .db-filter-grid { grid-template-columns: 1fr; }
        }
        @media (max-width: 480px) {
          .db-root { padding: 10px; gap: 12px; }
          .db-toprow { flex-direction: column; align-items: flex-start; }
        }
      `}</style>
    </div>
  );
};

export default Dashboard;

const STAT_STYLES: Record<string, {
  card: string; border: string; orb: string;
  iconBg: string; iconColor: string; iconShadow: string;
  badgeBg: string; badgeColor: string;
  valColor: string; lblColor: string;
}> = {
  blue: {
    card: "linear-gradient(155deg,#f5f8ff 0%,#eef2ff 60%,#f8f9ff 100%)",
    border: "#d4dbff", orb: "#6366f1",
    iconBg: "linear-gradient(135deg,#818cf8,#4f46e5)", iconColor: "#fff",
    iconShadow: "0 6px 18px rgba(99,102,241,.4),inset 0 1.5px 0 rgba(255,255,255,.45)",
    badgeBg: "linear-gradient(135deg,#818cf8,#4f46e5)", badgeColor: "#fff",
    valColor: "#1e1b4b", lblColor: "#4f46e5",
  },
  green: {
    card: "linear-gradient(155deg,#f0fff8 0%,#e6fff4 60%,#f5fffb 100%)",
    border: "#b2f5db", orb: "#00c896",
    iconBg: "linear-gradient(135deg,#00e5a8,#00a67c)", iconColor: "#fff",
    iconShadow: "0 6px 18px rgba(0,198,150,.4),inset 0 1.5px 0 rgba(255,255,255,.45)",
    badgeBg: "linear-gradient(135deg,#00e5a8,#00b889)", badgeColor: "#003d2a",
    valColor: "#006b4f", lblColor: "#00a67c",
  },
  red: {
    card: "linear-gradient(155deg,#fff5f5 0%,#ffe8e8 60%,#fff8f8 100%)",
    border: "#ffc5c5", orb: "#ff4d6d",
    iconBg: "linear-gradient(135deg,#ff7a87,#d63448)", iconColor: "#fff",
    iconShadow: "0 6px 18px rgba(214,52,72,.4),inset 0 1.5px 0 rgba(255,255,255,.45)",
    badgeBg: "linear-gradient(135deg,#ff7a87,#e04055)", badgeColor: "#fff",
    valColor: "#b01020", lblColor: "#d63448",
  },
  amber: {
    card: "linear-gradient(155deg,#fffdf0 0%,#fff8e0 60%,#fffdf5 100%)",
    border: "#fde68a", orb: "#f59e0b",
    iconBg: "linear-gradient(135deg,#fcd34d,#d97706)", iconColor: "#fff",
    iconShadow: "0 6px 18px rgba(217,119,6,.4),inset 0 1.5px 0 rgba(255,255,255,.45)",
    badgeBg: "linear-gradient(135deg,#fcd34d,#f59e0b)", badgeColor: "#451a03",
    valColor: "#92400e", lblColor: "#b45309",
  },
  orange: {
    card: "linear-gradient(155deg,#fff8f3 0%,#fff0e6 60%,#fff8f5 100%)",
    border: "#fed7aa", orb: "#f97316",
    iconBg: "linear-gradient(135deg,#fb923c,#ea580c)", iconColor: "#fff",
    iconShadow: "0 6px 18px rgba(234,88,12,.4),inset 0 1.5px 0 rgba(255,255,255,.45)",
    badgeBg: "linear-gradient(135deg,#fb923c,#ea580c)", badgeColor: "#fff",
    valColor: "#9a3412", lblColor: "#c2410c",
  },
};

const InfoTabs = ({ datesTop, timeFrameTop, selectOrg, selectClient, selectCard }: any) => {
  const [infoTabs, setInfoTabs] = useState<any>({});
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const { dashboardData } = useContext(ClientContext);
  const [dates, setDates] = useState(datesTop);
  const [timeFrame, setTimeFrame] = useState(timeFrameTop);

  const fetchClients = () => {
    setIsLoading(true);
    let data: any = {
      time_frame: timeFrame,
      org_ids: selectOrg?.length > 0 ? selectOrg?.map((m: any) => m?.id)?.toString() : "",
      client_ids: selectClient?.length > 0 ? selectClient?.map((m: any) => m?.id)?.toString() : "",
      card_type: selectCard?.length > 0 ? selectCard?.map((m: any) => m?.value)?.toString() : "",
    };
    if (dates) { data = { ...data, start_date: dates[0].toISOString().substring(0, 10), end_date: dates[1].toISOString().substring(0, 10) }; }
    if (timeFrame !== "custom") { delete data.start_date; delete data.end_date; }
    getAllTabs(dashboardData, data).then((d) => setInfoTabs(d)).catch(() => {}).finally(() => setIsLoading(false));
  };

  useEffect(() => { const t = setTimeout(fetchClients, 1000); return () => clearTimeout(t); }, [dashboardData, dates, timeFrame, selectOrg, selectClient, selectCard]);
  useEffect(() => { setDates(datesTop); setTimeFrame(timeFrameTop); }, [datesTop, timeFrameTop]);

  const WIDGETS = [
    { icon: <GrTransaction size={19} />,               label: "Total",    value: infoTabs?.totalTransactions,    color: "blue"   },
    { icon: <MdCheckCircle size={19} />,               label: "Approved", value: infoTabs?.transactionsApproved, color: "green"  },
    { icon: <MdCancel size={19} />,                    label: "Declined", value: infoTabs?.transactionsDeclined, color: "red"    },
    { icon: <MdOutlineReplayCircleFilled size={19} />, label: "Refunded", value: infoTabs?.transactionsRefunded, color: "amber"  },
    { icon: <MdOutlineError size={19} />,              label: "Errored",  value: infoTabs?.transactionsErrored,  color: "orange" },
  ];

  if (isLoading) {
    return (
      <div style={{ display: "flex", justifyContent: "center", padding: "32px 0" }}>
        <DivLoader className="h-6 w-6 border-blue-500" />
      </div>
    );
  }

  return (
    <div>
      <div className="sw-grid">
        {WIDGETS.map((w, i) => {
          const s = STAT_STYLES[w.color];
          const val = w.value != null ? Number(w.value).toLocaleString() : "—";
          return (
            <div key={i} className="sw-card" style={{ background: s.card, borderColor: s.border }}>
              {/* decorative orb */}
              <div className="sw-orb" style={{ background: `radial-gradient(circle,${s.orb},transparent)` }} />
              {/* shimmer */}
              <div className="sw-shine" style={{ animationDelay: `${i * 0.6}s` }} />

              {/* ── row: icon + count side by side ── */}
              <div className="sw-row">
                <div className="sw-icon" style={{ background: s.iconBg, color: s.iconColor, boxShadow: s.iconShadow }}>
                  {w.icon}
                </div>
                <div className="sw-nums">
                  <div className="sw-value" style={{ color: s.valColor }}>{val}</div>
                  <div className="sw-label" style={{ color: s.lblColor }}>{w.label}</div>
                </div>
              </div>

              {/* bottom accent bar */}
              <div className="sw-bar" style={{ background: s.iconBg }} />
            </div>
          );
        })}
      </div>

      <style>{`
        .sw-grid {
          display: grid;
          grid-template-columns: repeat(5, 1fr);
          gap: 14px;
        }

        .sw-card {
          border-radius: 24px;
          border: 1.5px solid;
          padding: 18px 18px 22px;
          position: relative;
          overflow: hidden;
          cursor: default;
          transition: transform .18s, box-shadow .18s;
        }
        .sw-card:hover {
          transform: translateY(-4px);
          box-shadow: 0 14px 36px rgba(0,0,0,.09);
        }

        /* decorative orb */
        .sw-orb {
          position: absolute; top: -44px; right: -44px;
          width: 140px; height: 140px; border-radius: 50%;
          opacity: .09; pointer-events: none;
        }

        /* shimmer sweep */
        .sw-shine {
          position: absolute; inset: 0; border-radius: 24px;
          background: linear-gradient(120deg,transparent 30%,rgba(255,255,255,.55) 50%,transparent 70%);
          animation: swShine 5s ease-in-out infinite;
          pointer-events: none; z-index: 0;
        }
        @keyframes swShine {
          0%,100% { opacity:0; transform:translateX(-100%); }
          50%      { opacity:1; transform:translateX(100%); }
        }

        /* ── icon + count row ── */
        .sw-row {
          display: flex;
          align-items: center;
          gap: 14px;
          position: relative;
          z-index: 1;
        }

        .sw-icon {
          width: 48px; height: 48px; border-radius: 14px;
          display: flex; align-items: center; justify-content: center;
          flex-shrink: 0;
        }

        .sw-nums {
          display: flex;
          flex-direction: column;
          gap: 3px;
          min-width: 0;
        }

        .sw-value {
          font-size: 26px; font-weight: 900; letter-spacing: -1.2px;
          line-height: 1; font-family: 'Plus Jakarta Sans', sans-serif;
          white-space: nowrap;
        }

        .sw-label {
          font-size: 9.5px; font-weight: 800; letter-spacing: .6px;
          text-transform: uppercase; white-space: nowrap;
        }

        /* bottom accent bar */
        .sw-bar {
          position: absolute; bottom: 0; left: 0; right: 0;
          height: 3px; border-radius: 0 0 24px 24px;
        }

        /* ── Responsive ── */
        @media (max-width: 1280px) {
          .sw-grid { grid-template-columns: repeat(3, 1fr); }
        }
        @media (max-width: 900px) {
          .sw-grid { grid-template-columns: repeat(2, 1fr); }
          .sw-value { font-size: 22px; }
        }
        @media (max-width: 480px) {
          .sw-grid { grid-template-columns: 1fr 1fr; gap: 10px; }
          .sw-card { padding: 14px 14px 18px; border-radius: 18px; }
          .sw-icon { width: 38px; height: 38px; border-radius: 11px; }
          .sw-value { font-size: 18px; }
          .sw-label { font-size: 8.5px; }
          .sw-row { gap: 10px; }
        }
      `}</style>
    </div>
  );
};

const AllADPayments = ({ type, datesTop, timeFrameTop, selectOrg, selectClient, selectCard }: any) => {
  const [payments, setPayments] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>();
  const [timeFrame, setTimeFrame] = useState(timeFrameTop);
  const [dates, setDates] = useState(datesTop);
  const { dashboardData } = useContext(ClientContext);

  const fetchPayments = () => {
    setIsLoading(true);
    let data: any = {
      time_frame: timeFrame,
      org_ids: selectOrg?.length > 0 ? selectOrg?.map((m: any) => m?.id)?.toString() : "",
      client_ids: selectClient?.length > 0 ? selectClient?.map((m: any) => m?.id)?.toString() : "",
      card_type: selectCard?.length > 0 ? selectCard?.map((m: any) => m?.value)?.toString() : "",
    };
    if (dates) { data = { ...data, start_date: dates[0].toISOString().substring(0, 10), end_date: dates[1].toISOString().substring(0, 10) }; }
    if (timeFrame !== "custom") { delete data.start_date; delete data.end_date; }
    getTransactionByCurrency(type, data, dashboardData)
      .then((d) => setPayments(Object.entries(d)?.map(([key, value]) => ({ key, value }))))
      .catch(() => {}).finally(() => setIsLoading(false));
  };

  useEffect(() => { setTimeFrame(timeFrameTop); setDates(datesTop); }, [timeFrameTop, datesTop]);
  useEffect(() => { const t = setTimeout(fetchPayments, 1000); return () => clearTimeout(t); }, [dashboardData, dates, timeFrame, selectOrg, selectClient, selectCard]);

  return <ADPaymentsList tableData={payments} isLoading={isLoading} timeFrame={timeFrame} setTimeFrame={setTimeFrame} type={type} dates={dates} setDates={setDates} />;
};

const LatestPayments = ({ paymentName, datesTop, timeFrameTop, selectOrg, selectClient, selectCard }: any) => {
  const [payments, setPayments] = useState<PaymentRowObj[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>();
  const [allGateways, setAllGateways] = useState<any>();
  const { dashboardData } = useContext(ClientContext);
  const [timeFrame, setTimeFrame] = useState(timeFrameTop);
  const [dates, setDates] = useState(datesTop);

  const fetchPayments = () => {
    setIsLoading(true);
    let data: any = {
      time_frame: timeFrame,
      org_ids: selectOrg?.length > 0 ? selectOrg?.map((m: any) => m?.id)?.toString() : "",
      client_ids: selectClient?.length > 0 ? selectClient?.map((m: any) => m?.id)?.toString() : "",
      card_type: selectCard?.length > 0 ? selectCard?.map((m: any) => m?.value)?.toString() : "",
    };
    if (dates) { data = { ...data, start_date: dates[0].toISOString().substring(0, 10), end_date: dates[1].toISOString().substring(0, 10) }; }
    if (timeFrame !== "custom") { delete data.start_date; delete data.end_date; }
    getRecentPayments(1, "", dashboardData, 10, data).then((d) => setPayments(d.payments)).catch(() => {}).finally(() => setIsLoading(false));
  };

  useEffect(() => { setTimeFrame(timeFrameTop); setDates(datesTop); }, [timeFrameTop, datesTop]);
  useEffect(() => { const t = setTimeout(fetchPayments, 1000); return () => clearTimeout(t); }, [dashboardData, dates, timeFrame, selectOrg, selectClient, selectCard]);
  useEffect(() => { getAllGatewaysSecond().then(setAllGateways).catch(() => {}); }, []);

  return <PaymentsListDashboard tableData={payments} fetchPayments={fetchPayments} isLoading={isLoading} paymentName={paymentName} allGateways={allGateways} />;
};